import React, {useRef, useState} from 'react';
import {Alert, Button, Card, Col, Container, Form, Row} from 'react-bootstrap';
import {SOCIAL_MEDIAS} from "./CONSTANTS";
import {addMessageToDB} from "../services/UserService";
import {useAuth} from "../contexts/AuthContext";
import {auth} from "../firebase";

export default function ContactUs() {
    const [errorAlert, setErrorAlert] = useState(false);
    const [loading, setLoading] = useState(false)

    const [email, setEmail] = useState();
    const [firstname, setFirstName] = useState();
    const [lastname, setlastname] = useState();
    const [subject, setSubject] = useState();
    const [message, setmessage] = useState();
    const [success, setSuccess] = useState(false);
    const [successText, setSuccessText] = useState();


    const handleSubmit = async e => {
        e.preventDefault()

        setLoading(true)
        if (!firstname) {
            setSuccess(true);
            setSuccessText("Ange Förnamn")
            return;
        }
        if (!lastname) {
            setSuccess(true);
            setSuccessText("Ange Efternamn")
            return
        }

        if (!email) {
            setSuccess(true);
            setSuccessText("Ange E-post")
            return
        }

        if (!subject) {
            setSuccess(true);
            setSuccessText("Ange ämne")
            return;
        }

        if (!message) {
            setSuccess(true);
            setSuccessText("Ange Meddelande")
            return;
        }


        try {
            setLoading(true);
            const values = await addMessageToDB(firstname, lastname, email, subject, message, auth.currentUser.uid)
            setLoading(false)
        } catch (e) {
            setErrorAlert(true)
        }

        window.location.reload()

        setLoading(false)
    }


    return (


        <Container className={"leadsGrid"}>


            <Row>
                {success ? <Alert variant={"warning"}>{successText}</Alert> : null}

{/*
                <Col>
                    <Form onSubmit={handleSubmit}>


                        <h6>
                            Har du en fråga och vill komma i kontakt med oss? <br/> Kontakta oss genom att fylla i
                            formuläret,
                            vi återkommer till dig inom kort. Vi kommer att åter komma till angiven e-post i formuläret.
                        </h6>
                        <Row>

                            <Form.Group className="mb-2" controlId="exampleForm.ControlInput1">
                                <Form.Label>FÖRNAMN</Form.Label>
                                <Form.Control type="text" placeholder="Förnamn"
                                              onChange={(e) => setFirstName(e.target.value)}/>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                <Form.Label>EFTERNAMN</Form.Label>
                                <Form.Control type="text" placeholder="Efternamn"
                                              onChange={(e) => setlastname(e.target.value)}/>
                            </Form.Group>

                        </Row>
                        <Row>
                            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                <Form.Label>E-POST</Form.Label>
                                <Form.Control type="email" placeholder="example@företag.se"
                                              onChange={(e) => setEmail(e.target.value)}/>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                <Form.Label>ÄMNE</Form.Label>
                                <Form.Control type="text" placeholder="Leads"
                                              onChange={(e) => setSubject(e.target.value)}/>
                            </Form.Group>
                        </Row>
                        <Row>
                            <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                <Form.Label>Skriv ditt meddelande här</Form.Label>

                                <Form.Control as="textarea" rows={6} onChange={(e) => setmessage(e.target.value)}/>
                            </Form.Group>
                        </Row>

                        <Button variant="outline-success" type={"submit"} onClick={() => setSuccess(!success)}>
                            Skicka
                        </Button>

                    </Form>
                </Col>
*/}

                <Col>
                    <h2>
                        Om Leadtub
                    </h2>

                    <h5>

                        Leadtub är en plattform som gör det möjligt för medarbetare i tjänsteföretag att bli
                        stjärnsäljare,
                        utan
                        att sälja! Fördelen med det är att våra kunder tar vara på hela potentialen i vardagens alla
                        möten
                        och
                        samtal. Det innebär en kostnadseffektiv och trygg tillväxt för företaget!
                        Genom våra effektiva digitala verktyg och behovsanalyser kommer möjligheter i vardagen till
                        sin
                        rätt. I
                        vårt unika nätverk kan dessutom företag i olika branscher tipsa varandra om identifierade
                        behov
                        på
                        ett
                        sätt där alla får sin belöning!
                        För när ett behov finns - då finns Leadtub alltid tillgängligt!

                    </h5>
                    <SOCIAL_MEDIAS/>

                    <br/>
                    <a href="https://leadtub.se/integritetspolicy" target="_blank" rel="noopener noreferrer">
                        <span>Integritetspolicy</span>
                    </a>
                    <br/>
                    <a href="https://leadtub.se/anvandarvillkor" target="_blank" rel="noopener noreferrer">
                        <span>Användarvilkor</span>
                    </a>
                    <hr />
                    <h6>
                        Du kan nå oss på
                        <a href="mailto:Info@leadtub.se">
                            Info@leadtub.se
                        </a>
                    </h6>
                </Col>


            </Row>

        </Container>


    )
}
